// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Collapsible_trigger__QC_FG","icon":"Collapsible_icon___LwVC","collapsible":"Collapsible_collapsible__hGo9k"};